import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
	SelectOption,
	SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";
import http from "../../../shared/utils/http";

export interface SelectPositionProps {
	label: string;
}

const SelectPosition: React.FC<SelectPositionProps> = ({ label }) => {
	const { t } = useTranslation();

	const [positions, setPositions] = useState<SelectOptions>([]);

	const { watch } = useFormContext();
	const watchSport = watch("sport");

	useEffect(() => {
		if (!watchSport) return;
		http.get("/utils/positions?sport=" + watchSport).then((response) => {
			setPositions(
				response.map(
					(position: { name: string; value: string }) =>
					({
						value: position.value,
						label: t(
							`sportData.positions.volleyball.${position.value}`,
							position.name
						),
					} as SelectOption)
				)
			);
		});
	}, [watchSport, t]);

	const { control } = useFormContext();
	return (
		<AcedSelect
			label={label}
			control={control}
			options={positions}
			placeholder={t("createJob.placeholder.select")}
			name="position"
			rules={{ required: t("createJob.validation.required") }}
		/>
	);
};

export default SelectPosition;
